// extracted by mini-css-extract-plugin
export default {"appShellLoading":"src-hellospa-components-app-shell-app-shell-module__appShellLoading--3LNPV"};